import { Box, Button, TextField, Typography } from '@mui/material';
import { setUserName } from '../../reducers/user/userSlice';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store';
import reqProvider from '../../util/requests/reqProvider';

interface RegistrationStep1Props {
  handleNextStep: () => void;
}

const RegistrationStep1: React.FC<RegistrationStep1Props> = ({ handleNextStep }) => {
  const email: string = useSelector((state: RootState) => state.user.userName);
  const [emailError, setEmailError] = useState<string>('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEmailChange = async () => {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      setEmailError('Email formátuma nem megfelelő');
      return;
    }
    const response = await reqProvider.post('auth/check-email', { email });
    if (response.data) {
      setEmailError('Ehhez az email címhez már tartozik fiók.');
      return;
    }
      setEmailError('');
      handleNextStep();
  };

  return(
<>
  {/*<Button variant={'outlined'} sx={button} onClick={()=>{setOpen(true)}}*/}
  {/*        startIcon={<GoogleIcon sx={{ color: 'black' }} />}>{'Regisztrálok Google fiókkal'}</Button>*/}
  <hr style={{ width: '100%' }} />
  <Box>
    <Typography variant={'caption'} lineHeight={1} color={'textSecondary'}>{"Olyan email címet adj meg, amelyet rendszeresen használsz munkavégzéshez."}</Typography>
    <TextField
      sx={{ mt: 2 }}
      fullWidth
      name={'email'}
      type="email"
      value={email}
      label={'Email cím'}
      onChange={(e) => dispatch(setUserName(e.target.value))}
      error={!!emailError}
      helperText={emailError}
    />
  </Box>
  <Button variant={'contained'} color={'primary'} onClick={handleEmailChange} > {'Tovább az adatok megadásához'} </Button>
  <hr style={{ width: '100%' }} />
  <Button variant={'outlined'} sx={{textTransform: 'none',
    borderRadius: '30px',
    fontWeight: '400',
    color: '#291520'}} onClick={()=> navigate('/login')}>{'Már van fiókom, belépek'}
  </Button>
</>
  )
}

export default RegistrationStep1;